module.exports = __webpack_public_path__ + "img/P150T_weapon_134.7e978c12.png";